/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

import AppTable from 'components/appTable';
import Empty from 'components/empty';
import SearchBox from 'components/form/searchBox';
import PanelBoxLayout from 'components/layout/panelBox';
import Toolbar from 'components/toolbar';
import { useActions } from 'common/hooks/useActions';
// import NotificationFilterPopup from "../filterForm";
import PaginationApp from 'components/pagination';
import StatusChip from 'components/statusChip';
import Value from 'components/value';
import { MISSING } from 'common/helpers/format';

import * as S from './styles';
import * as T from 'common/types';

const BellIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8a6 6 0 1 0-12 0c0 7-3 8-3 8h18s-3-1-3-8z" />
    <path d="M10.3 20a2 2 0 0 0 3.4 0" />
  </svg>
);

interface IProps {
  data: { list: []; totalPages: number };
  departments: [];
  loading: boolean;
}

export default function EventsTable({ data, departments, loading }: IProps) {
  const { notificationsCustomRequestAction } = useActions();
  const [meta, setMeta] = useState({
    page: 1,
    page_size: 10,
    search: '',
    type: ''
  });

  const fetchData = () => {
    notificationsCustomRequestAction(meta);
  };

  useEffect(() => {
    fetchData();
  }, [meta]);

  const handleChangePage = (page: number) => {
    setMeta({ ...meta, page });
  };

  const handleChangePageSize = (page_size: number) => {
    setMeta({ ...meta, page_size });
  };

  return (
    <S.Content>
      <PanelBoxLayout className="flush" contentStyle={{ padding: 0 }}>
        <Toolbar>
          <SearchBox
            onChange={(e) => setMeta({ ...meta, search: e, page: 1 })}
            placeholder="Search notifications"
            value={meta.search}
          />
          {/* <NotificationFilterPopup
            setFilter={setMeta}
            filter={meta}
            departments={departments}
          /> */}
        </Toolbar>
        <AppTable
          headers={[
            { id: 1, key: 'id', title: 'ID', dir: 'left', width: 84 },
            { id: 2, key: 'title', title: 'Title', dir: 'left' },
            { id: 3, key: 'department', title: 'Department', dir: 'left', width: 180 },
            { id: 4, key: 'floor', title: 'Floor', dir: 'left', width: 120 },
            { id: 5, key: 'sendToAll', title: 'Audience', dir: 'left', width: 130 }
          ]}
          data={data?.list}
          loading={loading}
          empty={
            <Empty
              icon={<BellIcon />}
              title={meta.search ? `No notifications match “${meta.search}”` : 'No notifications sent yet'}
              text={
                meta.search
                  ? 'Try a different term, or clear the search to see every notification.'
                  : 'Anything you send from here is kept as a record.'
              }
            />
          }
          altanfeethiFields={{
            id: (item: T.Pages.NotificationListItem) => (
              <S.Div className="text-left">
                <Value mono>{item?.id}</Value>
              </S.Div>
            ),
            /* The 50-character JS cut is gone; AppTable clips and titles. */
            title: (item: T.Pages.NotificationListItem) => (
              <S.Div className="text-left">
                <Value fallback={MISSING.provided}>{item?.title}</Value>
              </S.Div>
            ),
            /*
             * A notification sent to everyone carries no department and no
             * floor, so these two columns are empty on most rows. An em dash
             * says the field does not apply here; a blank cell said nothing.
             */
            department: (item: T.Pages.NotificationListItem) => (
              <S.Div className="text-left">
                <Value fallback={MISSING.none}>{item?.department}</Value>
              </S.Div>
            ),
            floor: (item: T.Pages.NotificationListItem) => (
              <S.Div className="text-left">
                <Value fallback={MISSING.none}>{item?.floor?.name}</Value>
              </S.Div>
            ),
            /*
             * This was a disabled checkbox — a control the reader cannot use,
             * standing in for a fact. It is who the notification went to,
             * said in words.
             */
            sendToAll: (item: T.Pages.NotificationListItem) => (
              <S.Div className="text-left">
                <StatusChip
                  domain="notificationAudience"
                  value={item?.sendToAll ? 'all' : 'targeted'}
                  fallback={<Value />}
                />
              </S.Div>
            )
          }}
        />
      </PanelBoxLayout>
      {data.totalPages ? (
        <PaginationApp
          page={meta.page}
          count={meta.page_size * data.totalPages}
          handleChangePage={(page: number) => handleChangePage(page)}
          key={data.totalPages}
          pageSize={meta.page_size}
          handleChangeTake={handleChangePageSize}
        />
      ) : (
        <></>
      )}
    </S.Content>
  );
}
